<div class="flex items-center">
  <button (click)="open()" mat-icon-button>
    <mat-icon svgIcon="mat:search"></mat-icon>
  </button>
  <mat-form-field [class.search-open]="isOpen" appearance="outline" class="flex-auto search">
    <mat-label>Search&hellip;</mat-label>
    <input #input (blur)="close()" matInput>
  </mat-form-field>
</div>
